import { Component, Input, OnInit } from '@angular/core';
import { MasterDataService } from '../masterdata/masterdata.service';
import { LabMDM } from '../masterdata/models/lab';
import { MessagesService } from '../messages/messages.service';
import { ErrorHandler } from '../utils/error-handler';
import * as cloneDeep from 'lodash/cloneDeep';
import { SelectableLab } from '../carrier/selectable-lab';
import { Controls } from '../masterdata/models/controls';
import { RegexFormatAndPosition } from '../masterdata/models/RegexFormatAndPosition';

@Component({
  selector: 'app-mdm-controls',
  templateUrl: './mdm-controls.component.html',
  styleUrls: ['./mdm-controls.component.css']
})
export class MdmControlsComponent implements OnInit {

  masterList: Controls;
  selectedMasterList: Controls;
  selectedLab: LabMDM;
  _labOptions: Array<LabMDM>;
  isNewMasterList: boolean;
  datepipe: any;

  @Input() masterLists: Controls[];
  @Input() controlHeaders: Array<any>;
  @Input() title: string;
  @Input() checkSelectedLab: SelectableLab;

  @Input() set labOptions(input: LabMDM[]) {
    this._labOptions = input.filter((lab: LabMDM) => lab.name === this.checkSelectedLab.lab.name);
  }

  errorHandler: ErrorHandler = new ErrorHandler();
  displayMasterListDialog: boolean = false;
  controlConfigurationName: string;
  showcontrols: boolean;
  active: boolean;
  regexFormat: string;
  position: string;
  constructor(private _messageService: MessagesService, private _masterDataService: MasterDataService) {
    this.showError = this.showError.bind(this);
  }

  ngOnInit() {
    this.regexFormat = "Regex Format";
    this.position = "Position";
  }

  date(date: any, arg1: string) {
    throw new Error('Method not implemented.');
  }

  controlRowSelect(event: any) {
    this.isNewMasterList = false;
    const { data } = event;
    const { lab = {} } = data;
    const { _id = '' } = lab;
    this.masterList = cloneDeep(data);
    this.masterList.lab = this._labOptions.find((labOption: LabMDM) => labOption._id === _id);
    this.displayMasterListDialog = true;
  }

  addNewControlConfiguration() {
    this.active = false;
    this.masterList = new Controls;
    this.controlConfigurationName = null;
    this.displayMasterListDialog = true;
    this.isNewMasterList = true;
  }

  controlSaveOrUpdate() {
    if (!this.masterLists || this.masterLists==null) {
      let controlsArray: Controls[] = [];
      this.masterLists = controlsArray;
      this.saveMasterData(controlsArray);
    }
    else {
      let masterLists = [...this.masterLists];
      if (this.isNewMasterList) {
        this.saveMasterData(masterLists);
      }
      else {
        this.updateMasterData(masterLists);
      }
    }
  }

  saveMasterData(masterLists: Controls[]) {
    this._masterDataService.saveControlConfiguration(this.masterList.lab, this.masterList).subscribe(
      results => {
        if (!results) {
          return;
        }
        masterLists = [...this.masterLists];
        masterLists.push(results.data);
        this.masterLists = masterLists;
        this.masterList = null;
        this.displayMasterListDialog = false;
        this._messageService.addSuccessMessage({ severity: 'success', summary: 'Control Saved Successfully!!!', detail: 'Control is created.' });
      },this.showError);
  }

  updateMasterData(masterLists: any[]) {
    this._masterDataService.updateControlConfiguration(this.masterList.lab, this.masterList).subscribe(
      results => {
        if (!results) {
          return;
        }
        masterLists[this.masterLists.indexOf(this.selectedMasterList)] = results.data;
        this.masterLists = masterLists;
        this.masterList = null;
        this.displayMasterListDialog = false;
        this._messageService.addSuccessMessage({ severity: 'success', summary: 'Updated Control Successfully!', detail: 'Control is updated.' });
      },this.showError);
  }

  showError(error:any) {
    const { status } = error;
        if (status === 409) {
          this._messageService.addErrorMessage({
            severity: 'error', summary: 'Duplicate Key',
            detail:'Already Created Control With Name '+this.masterList.controlConfigurationName
          });
        } else{
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    }

  isSaveDisabledControl() {
    if (this.masterList == undefined || this.masterList == null)
      return true;
    if (!this.masterList.controlConfigurationName || this.masterList.controlConfigurationName.trim() == "" || !this.masterList.lab) {
      return true;
    }

    let exisit = false;
    if (this.masterList.positiveExtractionControl) {
      exisit = this.validationForPositiveExtractionControl(exisit);
    }

    if (this.masterList.negativeExtractionControl) {
      exisit = this.validationForNegativeExtractionControl(exisit);
    }

    if (this.masterList.positivePCRControls) {
      exisit = this.validationForPositivePCRControls(exisit);
    }

    if (this.masterList.negativePCRControls) {
      exisit = this.validationForNegativePCRControls(exisit);
    }
    return exisit;
  }

  validationForPositiveExtractionControl(exisit: boolean) {
    this.masterList.positiveExtractionControl.forEach(positiveRegex => {
      if (positiveRegex.regexFormat == undefined || positiveRegex.regexFormat.trim() == "") {
        exisit = true;
      }
    });
    return exisit;
  }

  validationForNegativeExtractionControl(exisit: boolean) {
    this.masterList.negativeExtractionControl.forEach(negativeRegex => {
      if (negativeRegex.regexFormat == undefined || negativeRegex.regexFormat.trim() == "") {
        exisit = true;
      }
    });
    return exisit;
  }

  validationForNegativePCRControls(exisit: boolean) {
    this.masterList.negativePCRControls.forEach(negativePCRregex => {
      if (negativePCRregex.regexFormat == undefined || negativePCRregex.regexFormat.trim() == "") {
        exisit = true;
      }
    });
    return exisit;
  }

  validationForPositivePCRControls(exisit: boolean) {
    this.masterList.positivePCRControls.forEach(positivePCRregex => {
      if (positivePCRregex.regexFormat == undefined || positivePCRregex.regexFormat.trim() == "") {
        exisit = true;
      }
    });
    return exisit;
  }

  getValueFromSpinner(type: any) {
    switch (type) {
      case "numberOfPC": {
        this.dynamicpositiveExtractionControl();
        break;
      }
      case "numberOfNC": {
        this.dynamicnegativeExtractionControl();
        break;
      }
      case "numberOfPositivePCR": {
        this.dynamicpositivePCRControls();
        break;
      }
      case "numberOfNegativePCR": {
        this.dynamicnegativePCRControls();
        break;
      }
    }

  }

  dynamicpositiveExtractionControl() {
    if (!this.masterList.positiveExtractionControl) {
      this.masterList.positiveExtractionControl = [];
    }
    let lengthpositiveExtractionControl = this.masterList.positiveExtractionControl.length;

    if (this.masterList.numberOfPC < lengthpositiveExtractionControl) {
      for (let i = 0; i < lengthpositiveExtractionControl - this.masterList.numberOfPC; i++) {
        this.masterList.positiveExtractionControl.pop();
      }
    }
    else {
      for (let i = 0; i < this.masterList.numberOfPC - lengthpositiveExtractionControl; i++) {
        this.masterList.positiveExtractionControl.push(new RegexFormatAndPosition());
      }
    }
  }


  dynamicnegativeExtractionControl() {
    if (!this.masterList.negativeExtractionControl) {
      this.masterList.negativeExtractionControl = [];
    }
    let lengthOfnegativeExtractionControl = this.masterList.negativeExtractionControl.length;

    if (this.masterList.numberOfNC < lengthOfnegativeExtractionControl) {
      for (let i = 0; i < lengthOfnegativeExtractionControl - this.masterList.numberOfNC; i++) {
        this.masterList.negativeExtractionControl.pop();
      }
    }
    else {
      for (let i = 0; i < this.masterList.numberOfNC - lengthOfnegativeExtractionControl; i++) {
        this.masterList.negativeExtractionControl.push(new RegexFormatAndPosition());
      }
    }
  }

  dynamicnegativePCRControls() {
    if (!this.masterList.negativePCRControls) {
      this.masterList.negativePCRControls = [];
    }
    let lenOfnegativePCRControls = this.masterList.negativePCRControls.length;

    if (this.masterList.numberOfNegativePCR < lenOfnegativePCRControls) {
      for (let i = 0; i < lenOfnegativePCRControls - this.masterList.numberOfNegativePCR; i++) {
        this.masterList.negativePCRControls.pop();
      }
    }
    else {
      for (let i = 0; i < this.masterList.numberOfNegativePCR - lenOfnegativePCRControls; i++) {
        this.masterList.negativePCRControls.push(new RegexFormatAndPosition());
      }
    }
  }

  dynamicpositivePCRControls() {
    if (!this.masterList.positivePCRControls) {
      this.masterList.positivePCRControls = [];
    }
    let lengthOfpositivePCRControls = this.masterList.positivePCRControls.length;

    if (this.masterList.numberOfPositivePCR < lengthOfpositivePCRControls) {
      for (let i = 0; i < lengthOfpositivePCRControls - this.masterList.numberOfPositivePCR; i++) {
        this.masterList.positivePCRControls.pop();
      }
    }
    else {
      for (let i = 0; i < this.masterList.numberOfPositivePCR - lengthOfpositivePCRControls; i++) {
        this.masterList.positivePCRControls.push(new RegexFormatAndPosition());
      }
    }
  }

}